<template>
    <div class="enrolment">
      <el-dialog title="报名记录" :visible.sync="dialogVisibledelete" center>
        <template>
          <el-table :data="followList" stripe border style>
            <el-table-column prop="ErName" label="姓名" align="center"/>
            <el-table-column prop="ErPhone" label="电话" align="center"/>
            <el-table-column prop="ErTime" align="center" width label="报名时间"/>
          </el-table>
        </template>
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChangeBmrs"
          :page-size="5"
          :current-page="pageIndexBmrs"
          :total="totalBmrs"
          style="float:right;margin-top:10px;"/>
        <span slot="footer" style="text-align:center" class="dialog-footer"/>
      </el-dialog>
    </div>
</template>
<script>
import { SelectROASignRecordByRoaId } from "../../api/api";
export default {
    props: ["rooid"],
    data () {
        return {
            dialogVisibledelete: false,
            followList: [{}],
            pageIndexBmrs: 1, // 报名人数页码
            totalBmrs: 0
        }
    },
    methods: {
        // 初始化数据
        init () {
            this.dialogVisibledelete = true
            this.getPopNum();
        },
        // 查询报名人数列表
        getPopNum(scope) {
            var obj = {
                roaId: this.rooid,
                pageIndex: this.pageIndexBmrs, // 入参 报名人数页码
                pageSzie: 5
            }
            SelectROASignRecordByRoaId(obj).then(data=>{
                if(data.ResultCode == 1){
                    this.followList = data.ResultObj;
                    this.totalBmrs = data.RowsCount;
                }else{
                    this.followList = [];
                    this.totalBmrs = 0;
                }
            })
        },
        // 查询报名人数分页
        handleCurrentChangeBmrs(val) {
        this.pageIndexBmrs = val;
        this.getPopNum();
        },
    }
}
</script>
<style>
.enrolment .el-dialog__title {
  font-size: 22px !important;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// addPopNum.vue?4962b6a6